import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { loadFiles, setOutputFileAttribute, updateFileReviewStatus } from './thunks';
// import _ from 'lodash';
// import Tooltip from "react-bootstrap/Tooltip";
import './DocFileTable.css';

const DocFileTable = ({ 
  allowEdit = false, files = [], userInfo, reviewInfo,
  startLoadingFiles, startSetOutputFileAttribute, 
  startUpdateFileReviewStatus }) => {

  useEffect(() => {
  }, []);
  
  // const getFileTooltip = (filename) => {
  //   const [hoveredFile] = _.filter(files, (file) => file.fileName === filename);
  //   // console.log('>>> hoveredFile:', filename, hoveredFile);
  //   let tooltipText = '';
  //   if (hoveredFile) {
  //     tooltipText = `${hoveredFile.output_number} ${hoveredFile.output_title}`;
  //   }
  //   return tooltipText;
  // };
  
  const handleFileClick = (event) => {
    const fileName = event.target.parentElement.getAttribute('name');
    // console.log('>>> handleFileClick fileName:', fileName);
    startSetOutputFileAttribute({
      fileName: fileName,
      isSelected: true, 
    });
  };
  
  const content = (
    <div className="file-list-table">
      <table>
        <tbody>
        <tr key="Header">
          <th key="F">File Name</th>
        </tr>
        {files.map(file => 
          <tr key={file.fileName}>
            <td className={'file-item file-selected-' + file.isSelected} 
              key={file.fileName} name={file.fileName} 
              onClick={handleFileClick}>
              <div className="filename-text">{file.fileName}</div>
            </td>
          </tr>
        )}
        </tbody>
      </table>
    </div>
  );
  return content;
}

const mapState = state => ({
  files: state.files,
  userInfo: state.userInfo,
  reviewInfo: state.reviewInfo,
})

const mapDispatch = dispatch => ({
  startLoadingFiles: () => dispatch(loadFiles()),
  startSetOutputFileAttribute: (data) => dispatch(setOutputFileAttribute(data)),
  startUpdateFileReviewStatus: (data) => dispatch(updateFileReviewStatus(data)),
})

export default connect(mapState, mapDispatch)(DocFileTable);
